module.exports = __webpack_public_path__ + "img/c05_unitgallichorseman_Normal_ua.0efc2def.webp";